<span
  class="inline-flex items-center px-[8px] py-[4px] rounded-full font-bold"
  [ngClass]="getTagClass(type)"
  >{{ text }}</span
>
